module.exports = __webpack_public_path__ + "static/ActaAgate-Book-301ddf4df3b16c85274ca7c9751bd137.woff2";